module.exports = __webpack_public_path__ + "static/app/img/case_item_bg2.0b50544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/case_item_bg2.jpg
// module id = vTIt
// module chunks = 1